import styled, { css } from 'styled-components';

export const SelectWrapper = styled.div`
  background: ${props => props.theme.colors.white};
  width: 6.4em;
  height: 1.94em;
  border: 1px solid ${props => props.theme.colors.lightGray};
  border-radius: 2px;
  position: relative;
  ${props => props.theme.mediaQueries.tablet_big_down}{
    width: 5.9em;
    height: 30px;
  };
  ${props => props.filterLive && css`
    opacity: 0.3;
  `};

`;

export const ButtonWrapper = styled.div`
  background: ${props => props.theme.colors.dropDownLiveHub};
  width: 1.30em;
  height: 1.30em;
  border-radius: 2px;
  right: 0.3em;
  position: absolute;
  cursor: pointer;
  margin-top: 4px;
  z-index:9;
  ${props => props.theme.mediaQueries.tablet_big_down}{
    right: unset;
    left: 68px;
  }
`;

export const OptionsWrapper = styled.ul`
  margin-left: 0px !important;
  list-style: none;
  visibility: ${props => (props.isOpen ? 'visible' : 'hidden')};
  width: 6.4em;
  align-self: flex-start;
  position: absolute;
  left: -1px;
  padding-top: 0;
  top: ${props => (props.isOpen ? '-22px' : '1.6em')};
  border: 1px solid ${props => props.theme.colors.lightGray};
  border-top: none;
  border-radius: 0 0 2px 2px;
  background: ${props => props.theme.colors.white};
  z-index: 3;
  -webkit-margin-before: 0;
  -webkit-margin-after: 0;
  -webkit-padding-start: 0;
  ${props => props.theme.mediaQueries.tablet_big_down}{
    width: 5.9em;
  }
`;

export const Option = styled.li`
  line-height: 0.77;
  margin-bottom: 0px!important;
  padding: 7px 5px 7px 7px;
  cursor: pointer;
  text-transform: uppercase;
  position: relative;
  text-align: left;
  font-family: ${props => props.theme.fontSets.narrowMedium};
  &:hover{
    background: ${props => props.theme.colors.mainColorDark};
    color: ${props => props.theme.colors.mainFontColor};
  }
  &:hover&:nth-child(2) {
     margin-right:5px;
  }
  &:first-child {
    border-bottom:1px solid ${props => props.theme.colors.lightGray};
  }
  &:last-child {
    border-top:1px solid ${props => props.theme.colors.lightGray};
  }
  font-size: 13px;
`;

export const SelectedOption = styled.div`
  text-transform: uppercase;
  cursor: pointer;
  padding: 8px 0 0 7px;
  line-height: 1;
  position: absolute;
  align-self: flex-start;
  text-align: left;
  left: 0em;
  width: 6em;
  font-family: ${props => props.theme.fontSets.narrowMedium};
  font-size: 13px;
`;
